import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.928 8.576h-14a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h14a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2zM8.492.702H.942a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h7.55a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2zM11.085 16.466H.928a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h10.156a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2zM19.929 8.576h-2.6a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h2.6a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2zM13.492.702h-2.6a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h2.6a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2zM16.086 16.466h-2.6a.2.2 0 0 0-.2.2v2.6c0 .11.09.2.2.2h2.6a.2.2 0 0 0 .2-.2v-2.6a.2.2 0 0 0-.2-.2z",
      fill: "#000"
    })
  }));
};
export default SvgComponent;